import type { HTMLAttributes } from "react";
import { cn } from "@/shared/lib/utils";
import { cva, type VariantProps } from "@/shared/lib/variants";

/**
 * Page-level horizontal shell. Required for every page per design.md §5.
 * Hand-rolled `mx-auto max-w-...` is out of spec.
 */
const container = cva("mx-auto px-4 w-full", {
  variants: {
    size: {
      sm: "max-w-md",
      md: "max-w-3xl",
      "2xl": "max-w-2xl",
      "4xl": "max-w-4xl",
      "5xl": "max-w-5xl",
      "6xl": "max-w-6xl",
      lg: "max-w-7xl",
      full: "max-w-full",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

export interface ContainerProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof container> {}

export function Container({ size, className, ...props }: ContainerProps) {
  return <div className={cn(container({ size }), className)} {...props} />;
}
